"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditLogFilterSchema = exports.AuditLogCreateSchema = exports.AuditLogSchema = exports.AuditActorTypeSchema = void 0;
const zod_1 = require("zod");
const common_schemas_1 = require("./common.schemas");
const timestamp_schemas_1 = require("./timestamp.schemas");
// ============================================
// ACTOR TYPE ENUM
// ============================================
exports.AuditActorTypeSchema = zod_1.z.enum([
    'user', // Regular customer
    'merchant', // Merchant admin/staff
    'admin', // Admin user (legacy)
    'super_admin', // Platform super admin
    'system', // Automated system actions
]);
// ============================================
// INTERNAL BASE SCHEMA (without log_id, created_at)
// ============================================
const _AuditLogBaseSchema = zod_1.z.object({
    actor_id: common_schemas_1.uuidSchema.nullable(),
    actor_type: exports.AuditActorTypeSchema,
    merchant_id: zod_1.z.number().int().positive().nullable(),
    action: zod_1.z.string().min(1).max(50),
    entity_type: zod_1.z.string().min(1).max(50),
    entity_id: zod_1.z.number().int().positive().nullable(),
    details: zod_1.z.record(zod_1.z.unknown()).nullable(), // jsonb object in DB
    ip_address: zod_1.z.string().max(45).nullable(), // IPv4 or IPv6
});
// ============================================
// ENTITY SCHEMA (full database row)
// ============================================
exports.AuditLogSchema = _AuditLogBaseSchema.extend({
    log_id: zod_1.z.number().int().positive(),
    created_at: timestamp_schemas_1.timestampIsoSchema,
});
// ============================================
// CREATE INPUT SCHEMA (for service layer)
// ============================================
exports.AuditLogCreateSchema = _AuditLogBaseSchema;
// ============================================
// FILTER SCHEMA (for list/query endpoints)
// ============================================
exports.AuditLogFilterSchema = zod_1.z.object({
    merchant_id: zod_1.z.number().int().positive().optional(),
    actor_id: common_schemas_1.uuidSchema.optional(),
    actor_type: exports.AuditActorTypeSchema.optional(),
    action: zod_1.z.string().optional(),
    entity_type: zod_1.z.string().optional(),
    entity_id: zod_1.z.number().int().positive().optional(),
    start_date: timestamp_schemas_1.timestampIsoSchema.optional(),
    end_date: timestamp_schemas_1.timestampIsoSchema.optional(),
    limit: zod_1.z.number().int().min(1).max(100).default(50),
    cursor: zod_1.z.string().optional(),
});
